export default {
  data() {
    return {
      viewport: {
        width: 0,
        height: 0
      }
    }
  },
  created() {
    if (window.visualViewport) {
      this.viewport.width = window.visualViewport.width
      this.viewport.height = window.visualViewport.height
    } else {
      this.viewport.width = window.innerWidth
      this.viewport.height = window.innerHeight
    }
    window.addEventListener('resize', this.handleViewport)
    window.addEventListener('orientationchange', this.handleViewport)
  },
  computed: {
    isDesktop() {
      return this.viewport.width >= this.$screen.md
    },
    isMobile() {
      return this.viewport.width < this.$screen.md
    }
  },
  methods: {
    handleViewport() {
      const oldVal = {
        width: this.viewport.width,
        height: this.viewport.height
      }
      if (window.visualViewport) {
        this.viewport.width = window.visualViewport.width
        this.viewport.height = window.visualViewport.height
      } else {
        this.viewport.width = window.innerWidth
        this.viewport.height = window.innerHeight
      }
      if (this.viewportChange) this.viewportChange({oldVal, newVal: this.viewport})
      if (this.onMobileViewEnter) {
        if (oldVal.width >= this.$screen.md && this.viewport.width < this.$screen.md) this.onMobileViewEnter()
      }
      if (this.onDesktopViewEnter) {
        if (oldVal.width < this.$screen.md && this.viewport.width >= this.$screen.md) this.onDesktopViewEnter()
      }
      if (this.onWideDesktopViewEnter) {
        if (oldVal.width < this.$screen.lg && this.viewport.width >= this.$screen.lg) this.onWideDesktopViewEnter()
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleViewport)
    window.removeEventListener('orientationchange', this.handleViewport)
  }
}
